import {
  PusherActionType,
  PusherReduxAction,
} from '../../../../../../../../redux/pusher/PusherActions';
import { scheduleActions } from '../../../actions';
import { put, select } from 'redux-saga/effects';
import {
  selectCrewScheduleTimelineEntriesSaga,
  selectPreferredVersionSaga,
} from '../../../selectors-saga';
import { getRouter } from '../../../../../../../../redux/selectors';
import { RouterState } from 'connected-react-router';
import { isIgnoreUpdate } from '../helpers';
import { updateCrewScheduleViolations } from '../../../../../../../../redux/pages/crew-scheduling-v3/utils';
import { getCrewScheduleViolations } from '../../../selectors';

export function* handleCrewScheduleEntryDelete(
  action: PusherReduxAction<PusherActionType.CREW_SCHEDULE_ENTRY_DELETED>,
) {
  const { location } = (yield select(getRouter)) as RouterState;
  const crewScheduleViolations = yield select(getCrewScheduleViolations);
  if (!location.pathname.includes('crew-scheduling-v3')) {
    return;
  }

  try {
    const { payload } = action;

    // const { CrewScheduleSandboxID } = payload;
    // const preferredVersion = yield* selectPreferredVersionSaga();
    // if (isIgnoreUpdate(preferredVersion, CrewScheduleSandboxID)) {
    //   return;
    // }

    const existedEntries = yield* selectCrewScheduleTimelineEntriesSaga();
    const entryToDelete = existedEntries.find(
      crewScheduleEntry => crewScheduleEntry?.ID === payload?.ID,
    );
    const updatedEntries = existedEntries.filter(
      dutyScheduleTimelineEntry => dutyScheduleTimelineEntry?.ID !== payload?.ID,
    );

    yield updateCrewScheduleViolations(entryToDelete, crewScheduleViolations, true);
    yield put(scheduleActions.setState({ crewScheduleTimelineEntries: updatedEntries }));
    yield put(scheduleActions.deleteCrewFromAircraft({ assignedAircraftIDs: entryToDelete?.AssignedAircraftIDs, deletedCrewEntry: entryToDelete }));
  } finally {
  }
}
